<template>
  <n-modal class="card-record" :loading="$var('load')" @close="$emit('close')">
    <h2>
      Запись в журнале
      <span v-if="edit.records" style="float: right; font-size: .8rem"><n-button icon="trash" @click="remove" /></span>
    </h2>
    <div class="body">
      <div class="object">Проект: {{ project.title }}</div>
      <div>Статус: {{ utils.status(record.status) }}</div>
      <div>Автор: {{ record.author.fullName }}</div>

      <n-button v-if="edit.records" @click="$var('corrected', true)">Подписать</n-button>
      <n-button v-if="edit.master" @click="$var('waiting', true)">Подписать</n-button>
      <n-button v-if="edit.welder" @click="$var('accept', true)">Подписать</n-button>
      <n-button v-if="edit.recordsFinal" @click="$var('finish', true)">Подписать</n-button>
    </div>
    <br />
    <n-items>
      <n-datepicker title="Дата заполнения" v-bind="$form.input('publishedAt')" :text="!edit.records" />
      <n-input title="Смена" v-bind="$form.input('date')" :text="!edit.records" />
      <n-input title="Наименование соединяемых элементов; марка стали" v-bind="$form.input('title')" :text="!edit.records" />
      <n-input title="Место или номер (по чертежу или схеме) свариваемого элемента" v-bind="$form.input('place')" :text="!edit.records" />
      <n-input title="Марка применяемых сварочных материалов (проволока, флюс, электроды), номер партии" v-bind="$form.input('brand')" :text="!edit.records" />
      <n-input title="Атмосферные условия (температура воздуха, осадки, скорость ветра)" v-bind="$form.input('weather')" :text="!edit.records" />
      <n-input title="Клеймо" v-bind="$form.input('stigma')" :text="!edit.records" />
      <n-input title="Отметка о приемке сварного соединения" v-bind="$form.input('mark')" :text="!edit.master" />
      <n-input title="Замечания по контрольной проверке (производителя работ и др.)" v-bind="$form.input('remark')" :text="!edit.welder" />
    </n-items>

    <br />
    <n-divide>
      <n-button v-if="edit.records" color="success" @click="save">Сохранить</n-button>
      <n-button @click="$emit('close')">Закрыть</n-button>
    </n-divide>
    
    <c-modal-journal-do-sign v-if="$var('corrected')" @close="$var('corrected', false)" @submit="(s) => corrected('records', s)" />
    <c-modal-journal-do-sign v-if="$var('waiting')" @close="$var('waiting', false)" @submit="(s) => waiting('master', s)" />
    <c-modal-journal-do-sign v-if="$var('accept')" @close="$var('accept', false)" @submit="(s) => accept('welding', s)" />
    <c-modal-journal-do-sign v-if="$var('finish')" @close="$var('finish', false)" @submit="(s) => finish('recordsFinal', s)" />
  </n-modal>
</template>

<script>
import utils from 'utils'
import CModalJournalDoSign from 'components/journal/ModalDoSign'

export default {
  name: 'ModalRecord',
  components: { CModalJournalDoSign, },
  props: [ 'project', 'journal', ],
  data() {
    return {
      utils,
      record: { author: {}, },
      user: $app.auth.user(),
      tabs: [
        { name: 'info', title: 'Информация', callback: this.save, },
        { name: 'control', title: 'Проверяющие', },
      ],
      columns: [
        { title: 'Название', name: 'title', },
        { title: 'Расход', name: 'done', },
      ],
      translates: {
        attach: 'Приложения',
        schema: 'Исполнительные схемы',
        figure: 'Чертежи',
        input: 'Документы',
      },
    }
  },
  computed: {
    id() {
      return this.$route.query.show
    },
    edit() {
      return {
        records: this.record.status === 'formed' && $app.auth.can('journals_welding_records', this.project.id),
        master: this.record.status === 'corrected' && $app.auth.can('journals_welding_master', this.project.id),
        welder: this.record.status === 'waiting' && $app.auth.can('journals_welding_welder', this.project.id),
        recordsFinal: this.record.status === 'waitingFinish' && $app.auth.can('journals_welding_records', this.project.id),
      }
    },
  },
  watch: {
    '$route.query.id'() {
      this.load()
    },
  },
  created() {
    this.load()
    this.$form.init({})
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, 'welding', this.id).query({
        'with[author][with][participation]': null,
        'with[signs][with][author]': null,
        projectId: this.project.id,
      }).then((result) => {
        this.record = result.data.content
        this.$form.init(this.record)
      }).finally(() => {
        this.$var('load', false)
      })
    },
    corrected(name, sign) {
      this.$var('load', true)
      $api.journals.welding.records.corrected(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    save() {
      this.$var('load', true)
      $api.journals.welding.edit(this.record.id, this.$form.get()).then(() => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    remove() {
      this.$var('load', true)
      $api.journals.records.remove(this.journal.name, this.record.id).then(() => {
        this.load()
        this.$emit('close')
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    accept(name, sign) {
      this.$var('load', true)
      $api.journals.welding.records.accept(this.record.id, { sign, remark: this.$form.get('remark'), }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    waiting(name, sign) {
      this.$var('load', true)
      $api.journals.welding.records.waiting(this.record.id, { sign, mark: this.$form.get('mark'), }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    finish(name, sign) {
      this.$var('load', true)
      $api.journals.welding.records.finish(this.record.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-record {
  
  .weather {
    .env, .temperature, .wind {
      width: 150px;
      margin-right: 20px;
    }
  }
  

}
</style>
